<template>
    <legal-page-layout
        :title="$t('cookies.title')"
        :updated="$t('cookies.updated')"
        :paragraphs="$t('cookies.paragraphs')"
    ></legal-page-layout>
</template>

<script>
import LegalPageLayout from './LegalPageLayout.vue';

// Política de cookies de Nukli. Refleja lo que el sitio usa DE VERDAD:
// cookies/localStorage de sesión propios (nukli_*) y preferencias. No hay
// analytics ni cookies publicitarias; si algún día se añaden, actualiza esto
// y añade un banner de consentimiento.
export default {
    name: 'Cookies',
    components: { LegalPageLayout },
    data: () => ({
        translations: {
            en: {
                cookies: {
                    title: 'Cookie Policy',
                    updated: 'Last updated: July 9, 2026',
                    paragraphs: [
                        {
                            title: 'What are cookies?',
                            text: `Cookies are small files that a website stores in your browser to remember information between visits — for example, that you are signed in. Similar technologies such as localStorage serve the same purpose.
This page explains which ones https://nukliapp.com actually uses.`
                        },
                        {
                            title: 'Cookies and storage we use',
                            text: `We only use first-party, technical cookies and browser storage, strictly needed for the website to work:
- nukli_access, nukli_refresh, nukli_user (cookies, 30 days): keep your Nukli session open after you sign in.
- nukli_tokens, nukli_user (localStorage): same purpose, used by the web app itself.
- Interface preferences (localStorage): remember your language and theme.
We do NOT use analytics cookies, advertising cookies or any third-party tracking on this website.`
                        },
                        {
                            title: 'Third parties',
                            text: `If you subscribe to a paid plan, payment happens on Stripe's checkout pages, which use their own cookies under Stripe's cookie policy (https://stripe.com/cookies-policy/legal).`
                        },
                        {
                            title: 'How to manage them',
                            text: `Because these cookies are strictly technical, no prior consent banner is required — but you are free to delete or block them from your browser settings at any time. If you block them, signing in to your account area will not work.
Instructions per browser:
- Chrome: https://support.google.com/chrome/answer/95647
- Firefox: https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop
- Safari: https://support.apple.com/HT201265
- Edge: https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09`
                        },
                        {
                            title: 'Questions',
                            text: `If you have any doubt about this Cookie Policy, write to hola@nukliapp.com.`
                        }
                    ]
                }
            },
            es: {
                cookies: {
                    title: 'Política de Cookies',
                    updated: 'Última actualización: 9 de julio de 2026',
                    paragraphs: [
                        {
                            title: '¿Qué son las cookies?',
                            text: `Las cookies son pequeños ficheros que un sitio web guarda en tu navegador para recordar información entre visitas — por ejemplo, que has iniciado sesión. Tecnologías similares como localStorage cumplen la misma función.
Esta página explica cuáles usa realmente https://nukliapp.com.`
                        },
                        {
                            title: 'Cookies y almacenamiento que usamos',
                            text: `Solo usamos cookies y almacenamiento propios y técnicos, estrictamente necesarios para que la web funcione:
- nukli_access, nukli_refresh, nukli_user (cookies, 30 días): mantienen tu sesión de Nukli abierta tras iniciar sesión.
- nukli_tokens, nukli_user (localStorage): misma finalidad, usados por la propia web.
- Preferencias de interfaz (localStorage): recuerdan tu idioma y tema.
NO usamos cookies de analítica, ni publicitarias, ni ningún rastreo de terceros en esta web.`
                        },
                        {
                            title: 'Terceros',
                            text: `Si te suscribes a un plan de pago, el pago se realiza en las páginas de checkout de Stripe, que usan sus propias cookies según la política de cookies de Stripe (https://stripe.com/cookies-policy/legal).`
                        },
                        {
                            title: 'Cómo gestionarlas',
                            text: `Como estas cookies son estrictamente técnicas, no requieren banner de consentimiento previo — pero puedes borrarlas o bloquearlas desde la configuración de tu navegador cuando quieras. Si las bloqueas, no podrás iniciar sesión en tu área de cuenta.
Instrucciones por navegador:
- Chrome: https://support.google.com/chrome/answer/95647
- Firefox: https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop
- Safari: https://support.apple.com/HT201265
- Edge: https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09`
                        },
                        {
                            title: 'Dudas',
                            text: `Si tienes cualquier duda sobre esta Política de Cookies, escríbenos a hola@nukliapp.com.`
                        }
                    ]
                }
            },
            ca: {
                cookies: {
                    title: 'Política de Cookies',
                    updated: 'Última actualització: 9 de juliol de 2026',
                    paragraphs: [
                        {
                            title: 'Què són les cookies?',
                            text: `Les cookies són petits fitxers que un lloc web guarda al teu navegador per recordar informació entre visites — per exemple, que has iniciat sessió. Tecnologies similars com localStorage compleixen la mateixa funció.
Aquesta pàgina explica quines usa realment https://nukliapp.com.`
                        },
                        {
                            title: 'Cookies i emmagatzematge que usem',
                            text: `Només usem cookies i emmagatzematge propis i tècnics, estrictament necessaris perquè la web funcioni:
- nukli_access, nukli_refresh, nukli_user (cookies, 30 dies): mantenen la teva sessió de Nukli oberta després d'iniciar sessió.
- nukli_tokens, nukli_user (localStorage): mateixa finalitat, usats per la pròpia web.
- Preferències d'interfície (localStorage): recorden el teu idioma i tema.
NO usem cookies d'analítica, ni publicitàries, ni cap rastreig de tercers en aquesta web.`
                        },
                        {
                            title: 'Tercers',
                            text: `Si et subscrius a un pla de pagament, el pagament es realitza a les pàgines de checkout de Stripe, que usen les seves pròpies cookies segons la política de cookies de Stripe (https://stripe.com/cookies-policy/legal).`
                        },
                        {
                            title: 'Com gestionar-les',
                            text: `Com que aquestes cookies són estrictament tècniques, no requereixen banner de consentiment previ — però pots esborrar-les o bloquejar-les des de la configuració del teu navegador quan vulguis. Si les bloqueges, no podràs iniciar sessió a la teva àrea de compte.
Instruccions per navegador:
- Chrome: https://support.google.com/chrome/answer/95647
- Firefox: https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop
- Safari: https://support.apple.com/HT201265
- Edge: https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09`
                        },
                        {
                            title: 'Dubtes',
                            text: `Si tens qualsevol dubte sobre aquesta Política de Cookies, escriu-nos a hola@nukliapp.com.`
                        }
                    ]
                }
            }
        }
    }),
    methods: {
        $t(key) {
            const lang = this.$root.currentLanguage || 'ca';
            const dict = this.translations[lang] || this.translations.en;
            const translation = key.split('.').reduce((obj, i) => obj && obj[i], dict);
            return translation || key;
        }
    }
};
</script>
